import React, { useState } from "react";
import Layout from "../../components/layout";
import useRead from "../../hooks/useRead";
import { useForm } from "react-hook-form";
import useCreate from "../../hooks/useCreate";
import { Alert } from "@mui/material";

const CompanySettings = () => {
  const [isSuccess, setIsSuccess] = useState(false);

  // Form code
  const { register, setValue, handleSubmit } = useForm({
    defaultValues: {
      is_minium_cart_allowed: false,
      minium_cart_value: null,
      is_shipping_allowed: false,
      shipping_threshold: null,
      shipping_value: null,
      is_cod_allowed: false,
      cod_value: null,
    },
  });

  // Fetch company settings
  const { queryData } = useRead({
    url: "fetch_company_settings",
    method: "GET",
    onSuccess: (data) => {
      const resData = data.data;
      setValue("is_minium_cart_allowed", resData.is_minium_cart_allowed);
      setValue("minium_cart_value", resData.minium_cart_value);
      setValue("is_shipping_allowed", resData.is_shipping_allowed);
      setValue("shipping_threshold", resData.shipping_threshold);
      setValue("shipping_value", resData.shipping_value);
      setValue("is_cod_allowed", resData.is_cod_allowed);
      setValue("cod_value", resData.cod_value);
    },
  });

  //   Code to save settings
  const { setDataToServer } = useCreate({
    url: "add_company_settings",
    onSuccess: (data) => {
      setIsSuccess(true);
      setTimeout(() => {
        setIsSuccess(false);
      }, 3000);
    },
  });

  const onSubmit = (data) => {
    setDataToServer.mutate(data);
  };

  const onError = (errors) => {};

  const closeSuccessAlert = () => {
    setIsSuccess(false);
  };

  return (
    <Layout>
      <div className="company_settings__container">
        <div className="company_settings__head headingBorder__b">
          <h2 className="titleHeading">Company Settings</h2>
        </div>

        <form
          className="flex flex-col items-center w-full"
          onSubmit={handleSubmit(onSubmit, onError)}
        >
          <div className="grid grid-cols-2 gap-5 mt-10 w-full">
            <div className="bg-white p-5 space-y-5">
              <p className="text-lg font-semibold">
                Minimum cart value settings
              </p>
              <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  name="min-cart-value"
                  {...register("is_minium_cart_allowed")}
                  id="min-cart-value"
                />
                <label htmlFor="min-cart-value">
                  Enable minimum cart value
                </label>
              </div>

              <div className="flex items-center space-x-2">
                <label htmlFor="min-cart-threshold">Threshold:</label>
                <input
                  type="number"
                  {...register("minium_cart_value")}
                  id="min-cart-threshold"
                  className="input w-40"
                />
              </div>
            </div>

            <div className="bg-white p-5 space-y-5">
              <p className="text-lg font-semibold">Shipping charges settings</p>

              <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  id="enable-shipping"
                  {...register("is_shipping_allowed")}
                />
                <label htmlFor="enable-shipping">Enable shipping charges</label>
              </div>

              <div className="flex items-center space-x-2">
                <label htmlFor="shipping-threshold">Threshold:</label>
                <input
                  type="number"
                  {...register("shipping_threshold")}
                  id="shipping-threshold"
                  className="input w-40"
                />
              </div>

              <div className="flex items-center space-x-2">
                <label htmlFor="shipping-value">Shipping charges:</label>
                <input
                  type="number"
                  {...register("shipping_value")}
                  id="shipping-value"
                  className="input w-40"
                />
              </div>
            </div>

            <div className="bg-white p-5 space-y-5">
              <p className="text-lg font-semibold">Cash on delivery settings</p>

              <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  name="min-cart-value"
                  id="enable-cod"
                  {...register("is_cod_allowed")}
                />
                <label htmlFor="enable-cod">Enable cash on delivery</label>
              </div>

              <div className="flex items-center space-x-2">
                <label htmlFor="cod-charges">Cash on delivery charges:</label>
                <input
                  type="number"
                  {...register("cod_value")}
                  id="cod-charges"
                  className="input w-40"
                />
              </div>
            </div>
          </div>

          <input
            type="submit"
            className=" primaryBtn-outlined px-3 py-1.5 rounded-md disabled:opacity-70 font-bold bg-white mt-5"
            value="Save Settings"
            disabled={setDataToServer?.isLoading}
          />
          {setDataToServer?.isLoading && (
            <div className="mt-5 w-full text-center">Saving...</div>
          )}
        </form>
        {isSuccess && (
          <Alert
            onClose={closeSuccessAlert}
            className="mb-4 mt-10"
            severity="success"
            sx={{ width: "100%" }}
          >
            Company settings updated successfully!
          </Alert>
        )}
      </div>
    </Layout>
  );
};

export default CompanySettings;
